import React, { useState } from 'react';
import LazyImage from './LazyImage';
import '../styles/BookUs.css';

const BookUs = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  // Replace with your actual WhatsApp number (include country code, no + or spaces)
  const whatsappNumber = '237670350201'; // Example: 919812345678 for +91 98123 45678
  const defaultMessage = 'Hi! I would like to book a photography session with Horazel.';
  
  const openWhatsApp = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(url, '_blank');
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className={`whatsapp-float ${isOpen ? 'open' : ''}`}>
        <button 
          className="whatsapp-button"
          onClick={openWhatsApp}
          aria-label="Book us on WhatsApp"
        >
          <svg 
            viewBox="0 0 32 32" 
            className="whatsapp-icon"
            fill="currentColor"
          >
            <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.924 0-7.435 6.047-13.482 13.482-13.482s13.482 6.047 13.482 13.482c0 7.435-6.047 13.467-13.482 13.467zM21.305 18.83c-0.308-0.154-1.832-0.905-2.116-1.006-0.284-0.103-0.491-0.154-0.697 0.154s-0.8 1.006-0.98 1.211c-0.179 0.205-0.359 0.231-0.667 0.077s-1.298-0.479-2.471-1.526c-0.913-0.815-1.53-1.821-1.709-2.129s-0.019-0.474 0.135-0.626c0.139-0.139 0.308-0.359 0.462-0.539s0.205-0.308 0.308-0.513c0.103-0.205 0.051-0.385-0.026-0.539s-0.697-1.678-0.955-2.299c-0.251-0.605-0.506-0.523-0.697-0.533-0.179-0.009-0.385-0.011-0.590-0.011s-0.539 0.077-0.821 0.385c-0.282 0.308-1.078 1.054-1.078 2.571s1.104 2.983 1.258 3.188c0.154 0.205 2.163 3.305 5.24 4.635 0.732 0.317 1.304 0.506 1.75 0.648 0.735 0.234 1.406 0.201 1.936 0.122 0.591-0.088 1.832-0.749 2.090-1.472s0.257-1.344 0.179-1.472c-0.077-0.128-0.282-0.205-0.590-0.359z"/>
          </svg>
          <span className="whatsapp-text">Book Us</span>
        </button>
      </div>

      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h2 className="contact-title">
                LET'S CREATE <span className="text-brand">TOGETHER</span>
              </h2>
              <p className="contact-description">
                Ready to capture your special moments? Get in touch with us today and let's create something extraordinary together.
              </p>
              
              <div className="contact-details">
                <div className="contact-item">
                  <span className="contact-label">Phone</span>
                  <a href={`tel:+${whatsappNumber}`} className="contact-value">
                    +91 9812 3456 78
                  </a>
                </div>
                <div className="contact-item">
                  <span className="contact-label">Email</span>
                  <a href="mailto:info@horazel.com" className="contact-value">
                    info@horazel.com
                  </a>
                </div>
                <div className="contact-item">
                  <span className="contact-label">Location</span>
                  <span className="contact-value">
                    Mumbai, India
                  </span>
                </div>
              </div>

              <button 
                className="book-now-btn"
                onClick={openWhatsApp}
              >
                <svg 
                  viewBox="0 0 32 32" 
                  className="btn-whatsapp-icon"
                  fill="currentColor"
                >
                  <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.924 0-7.435 6.047-13.482 13.482-13.482s13.482 6.047 13.482 13.482c0 7.435-6.047 13.467-13.482 13.467zM21.305 18.83c-0.308-0.154-1.832-0.905-2.116-1.006-0.284-0.103-0.491-0.154-0.697 0.154s-0.8 1.006-0.98 1.211c-0.179 0.205-0.359 0.231-0.667 0.077s-1.298-0.479-2.471-1.526c-0.913-0.815-1.53-1.821-1.709-2.129s-0.019-0.474 0.135-0.626c0.139-0.139 0.308-0.359 0.462-0.539s0.205-0.308 0.308-0.513c0.103-0.205 0.051-0.385-0.026-0.539s-0.697-1.678-0.955-2.299c-0.251-0.605-0.506-0.523-0.697-0.533-0.179-0.009-0.385-0.011-0.590-0.011s-0.539 0.077-0.821 0.385c-0.282 0.308-1.078 1.054-1.078 2.571s1.104 2.983 1.258 3.188c0.154 0.205 2.163 3.305 5.24 4.635 0.732 0.317 1.304 0.506 1.75 0.648 0.735 0.234 1.406 0.201 1.936 0.122 0.591-0.088 1.832-0.749 2.090-1.472s0.257-1.344 0.179-1.472c-0.077-0.128-0.282-0.205-0.590-0.359z"/>
                </svg>
                BOOK NOW VIA WHATSAPP
              </button>
            </div>

            <div className="contact-image">
              <LazyImage 
                src={require('../assets/images/DSC_5352.jpg')} 
                alt="Contact us"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookUs;
